import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '../../bySchoolClass/constants';
import {
  getClassDetail,
  getClassDetailStatus,
  loadClassDetail as loadClassDetailAction,
} from '../../bySchoolClass';

export const useClassDetail = (classId) => {
  const classDetail = useSelector((state) => getClassDetail(state, classId));

  const classDetailStatus = useSelector((state) =>
    getClassDetailStatus(state, classId)
  );

  const dispatch = useDispatch();

  const loadClassDetail = useCallback(
    () => dispatch(loadClassDetailAction.signal(classId)),
    [classId, dispatch]
  );

  useEffect(() => {
    loadClassDetail();
  }, [loadClassDetail]);

  const error =
    classDetailStatus === STATUS.ERROR || classDetailStatus === STATUS.FAILURE;

  if (error) {
    console.error(
      'There was an error loading data to classDetail',
      classDetailStatus
    );
  }

  return {
    classDetail,
    reloadClassDetail: loadClassDetail,
    loading: classDetailStatus === STATUS.LOADING,
    error,
  };
};

useClassDetail.STATUS = STATUS;
